import React from "react";
import { Link } from "react-router-dom";

const MenuItemNodes = ({ categorias, productoActual, categoriaActual }) => {
    let menuItemNodes = categorias.map(function (cate, indexCate) {
        let hasAProgram = (cate.programas && cate.programas.length == 1);
        let program = undefined;

        if (hasAProgram) {
            program = cate.programas[0];

            let active = false;

            if (cate.codigo.toLowerCase() == categoriaActual.toLowerCase())
                active = true;

            return (
                <li key={indexCate}>
                    <Link to={"/" + productoActual
                        + "/" + cate.codigo
                        + "/" + program.codigo
                        + "/" + program.codigoPantalla}
                        className={active ? 'active' : ''}>{cate.descripcion} </Link>
                </li>
            );
        } else {
            let subMenuItemNodes = cate.programas.map(function (prog, indexProg) {
                return (
                    <li key={indexProg}>
                        <Link to={"/" + productoActual
                            + "/" + cate.codigo
                            + "/" + prog.codigo
                            + "/" + prog.codigoPantalla}>{prog.descripcion}
                        </Link>
                    </li>
                );
            });

            let newActiveClass = "dropdown-toggle ";

            if (cate.codigo.toLowerCase() == categoriaActual.toLowerCase()) {
                newActiveClass += "active";
            }

            return (
                <li className="dropdown" key={indexCate + "_b"}>
                    <a href="#" className={newActiveClass} data-toggle="dropdown">
                        {cate.codigo} <b className="caret"></b></a>
                    <ul className="dropdown-menu"> {subMenuItemNodes} </ul>
                </li>
            );
        }

        return menuItemNodes;
    });

    return (
        <ul className={"nav navbar-nav no-overflow-y " + productoActual.toLowerCase()}>
            {menuItemNodes}
        </ul>
    );
}

const MenuCategoriasPrograma = (props) => {
    let newActiveClass = "dropdown-toggle ";
    const { categorias, productoActual, categoriaActual } = props;

    return (
        <MenuItemNodes categorias={categorias} productoActual={productoActual} categoriaActual={categoriaActual} />
    );
}

export default MenuCategoriasPrograma;

















/*
import React from "react";
import { Link } from "react-router";

var CategoriesProgramMenu = React.createClass({
    render: function () {
        let categories = this.props.categories || [];
        let currentProduct = this.props.currentProduct;
        let currentCategory = this.props.currentCategory;

        let menuItemNodes = categories.map(function (cate, indexCate) {
            let hasAProgram = (cate.programs && cate.programs.length == 1);
            let program = undefined;

            if (hasAProgram) {
                program = cate.programs[0];

                return <li key={indexCate}>
                    <Link to={"/" + currentProduct
                        + "/" + cate.code
                        + "/" + program.code
                        + "/" + program.screenCode}
                        activeClassName="active">{program.code} </Link>
                </li>;
            } else {
                let subMenuItemNodes = cate.programs.map(function (prog, indexProg) {
                    return <li key={indexProg}>
                        <Link to={"/" + currentProduct
                            + "/" + cate.code
                            + "/" + prog.code
                            + "/" + prog.screenCode}>{prog.description} </Link></li>
                });

                let newActiveClass = "dropdown-toggle ";

                if (cate.code.toLowerCase() == currentCategory.toLowerCase()) {
                    newActiveClass += "active";
                }

                return <li className="dropdown" key={indexCate + "_b"}>
                    <a href="#" className={newActiveClass} data-toggle="dropdown">
                        {cate.code} <b className="caret"></b></a>
                    <ul className="dropdown-menu"> {subMenuItemNodes} </ul>
                </li>;
            }
        });

        return (
            <ul className={"nav navbar-nav no-overflow-y " + currentProduct.toLowerCase()}>
                {menuItemNodes}
            </ul>
        );
    }
});

module.exports = CategoriesProgramMenu;
*/


// WEBPACK FOOTER //
// ./Portico/App/Screens/MenuCategorias/components/MenuCategoriasPrograma.jsx